(function ($) {
    'use strict';

    // Sets the disabled state of an element
    function setDisabled(disabled) {

        if ($(this).data("auth") == "forbidden") {
            return;
        }

        $(this).prop("disabled", disabled === undefined ? true : disabled);

        return this;
    }

    // Sets the checked state of a checkbox
    function setChecked(checked) {
        $(this).prop("checked", checked === undefined ? true : checked);

        return this;
    }

    // toggle the class "_pulse"
    function togglePulse(state) {
        $(this).toggleClass("_pulse", state);
        return this;
    }

    jQuery.fn.extend({
        setDisabled,
        setChecked,
        togglePulse
    });

    // Are we on a mobile sized screen (<576px)
    jQuery.isMobile = function () {
        return window.innerWidth < 576
    };

    // Custom event for detecting enter pressed
    jQuery.event.special.enterpressed = {
        delegateType: "keydown",
        bindType: "keydown",
        handle: function (event) {
            if (event.key === 'Enter') {
                return event.handleObj.handler.apply(this, arguments);
            }
        }
    };

    // Custom event for detecting tab pressed (tab forward)
    jQuery.event.special.tabforward = {
        delegateType: "keydown",
        bindType: "keydown",
        handle: function (event) {
            if (event.key === 'Tab' && !event.shiftKey) {
                return event.handleObj.handler.apply(this, arguments);
            }
        }
    };

    // Custom event for detecting shift + tab pressed (tab backward)
    jQuery.event.special.tabbackward = {
        delegateType: "keydown",
        bindType: "keydown",
        handle: function (event) {
            if (event.shiftKey && event.key === 'Tab') {
                return event.handleObj.handler.apply(this, arguments);
            }
        }
    };

})(jQuery);